/**
 * 通用方法
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  // eslint-disable-next-line camelcase
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    // eslint-disable-next-line standard/computed-property-even-spacing
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  // eslint-disable-next-line camelcase
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime (time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject (url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength (str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param (json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj (url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text (val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge (target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass (element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime (type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce (func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone (source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr (arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString () {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass (ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass (ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass (ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

/**
 * Number转字符串加0，包含了对毫秒的处理
 * @param {Number} number 数字
 */
export function addZero (number, isMilliseconds) {
  number = Number(number)
  // 存储处理好的数字
  let disposeNumber = number
  if (!isNaN(number)) {
    if (isMilliseconds) { // 毫秒处理
      if (number >= 0 && number < 10) {
        disposeNumber = `00${number}`
      } else if (number >= 10 && number < 100) {
        disposeNumber = `0${number}`
      } else if (number >= 1000) {
        disposeNumber = '000'
      }
    } else if (number >= 0 && number < 10) { // 正常数字处理
      disposeNumber = `0${number}`
    }
    return disposeNumber.toString()
  }
}

/**
 * 获取当前时间，输出格式为"yyyy-MM-dd HH:mm:ss 毫秒"的时间
 * @param {String} assignDate 指定日期，格式为Date()能读取的时间日期格式
 * @returns {Object} 返回处理好的日期数据
 */
export function getNowFormatDate (assignDate) {
  let date = new Date(assignDate)
  // 若没有指定时间
  if (!assignDate || date.toString === 'Invalid Date') {
    date = new Date()
  }
  const dateInfo = {
    normalDate: { // 正常时间信息
      year: date.getFullYear(), // 年
      month: addZero(date.getMonth() + 1), // 月
      day: addZero(date.getDate()), // 日
      hours: addZero(date.getHours()), // 时
      minutes: addZero(date.getMinutes()), // 分
      seconds: addZero(date.getSeconds()), // 秒
      milliseconds: addZero(date.getMilliseconds(), true) // 毫秒
    },
    UTCDate: { // UTC时间信息
      year: date.getUTCFullYear(), // 年
      month: addZero(date.getUTCMonth() + 1), // 月
      day: addZero(date.getUTCDate()), // 日
      hours: addZero(date.getUTCHours()), // 时
      minutes: addZero(date.getUTCMinutes()), // 分
      seconds: addZero(date.getUTCSeconds()), // 秒
      milliseconds: addZero(date.getUTCMilliseconds(), true) // 毫秒
    }
  }

  // 设置输出格式
  // 格式1 "yyyy-MM-dd HH:mm:ss 毫秒"
  dateInfo.normalDate.format1 = `${dateInfo.normalDate.year}-${dateInfo.normalDate.month}-${dateInfo.normalDate.day} ${dateInfo.normalDate.hours}:${dateInfo.normalDate.minutes}:${dateInfo.normalDate.seconds} ${dateInfo.normalDate.milliseconds}`
  dateInfo.UTCDate.format1 = `${dateInfo.UTCDate.year}-${dateInfo.UTCDate.month}-${dateInfo.UTCDate.day} ${dateInfo.UTCDate.hours}:${dateInfo.UTCDate.minutes}:${dateInfo.UTCDate.seconds} ${dateInfo.UTCDate.milliseconds}`
  // 格式2 "yyyy-MM-dd HH:mm"
  dateInfo.normalDate.format2 = `${dateInfo.normalDate.year}-${dateInfo.normalDate.month}-${dateInfo.normalDate.day} ${dateInfo.normalDate.hours}:${dateInfo.normalDate.minutes}`
  dateInfo.UTCDate.format2 = `${dateInfo.UTCDate.year}-${dateInfo.UTCDate.month}-${dateInfo.UTCDate.day} ${dateInfo.UTCDate.hours}:${dateInfo.UTCDate.minutes}`
  // 格式3 "yyyy-MM-dd"
  dateInfo.normalDate.format1Date = `${dateInfo.normalDate.year}-${dateInfo.normalDate.month}-${dateInfo.normalDate.day}`
  dateInfo.UTCDate.format1Date = `${dateInfo.UTCDate.year}-${dateInfo.UTCDate.month}-${dateInfo.UTCDate.day}`
  // 格式4 "yyyyMMdd"
  dateInfo.normalDate.format3Date = `${dateInfo.normalDate.year}${dateInfo.normalDate.month}${dateInfo.normalDate.day}`
  dateInfo.UTCDate.format3Date = `${dateInfo.UTCDate.year}${dateInfo.UTCDate.month}${dateInfo.UTCDate.day}`

  // 返回最后处理的对象
  return dateInfo
}

/**
 * 返回当前时间的epochtime
 */
export function getEpochtime () {
  const date = new Date()
  return date.getTime()
}

/**
 * 获取系统当前时间偏移量
 */
export function getTimezoneOffset () {
  return -(new Date().getTimezoneOffset() * 60)
}

/**
 * 转译运单状态
 * @param {String} status 运单状态
 * @returns {String} 运单状态的中文描述
 */
export function getStatus (waybillStatus, processStatus) {
  switch (waybillStatus) {
    case 'Processing': // 只有运单为执行状态下才显示真实状态
      switch (processStatus) {
        // 出库状态
        case 'WaitingForTask':
          return '待生成打包任务'
        case 'WaitingForPicking':
          return '待拣货'
        case 'WaitingForPacking':
          return '待打包'
        case 'WaitingForOutbound':
          return '待出库'
        // 入库状态
        case 'WaitingForSign':
          return '待签收'
        case 'WaitingForInspection':
          return '待验货'
        case 'WaitingForPutOnShelf':
          return '待上架'
        default:
          return processStatus
      }
    case 'New': // 待处理状态下的运单
      return '-待处理-'
    default: // 其余状态
      return `-${getWaybillStatus(waybillStatus)}-`
  }
}

/**
 * 返回出库单状态的中文形式
 * @param {String} status 出库单状态
 */
export function getWaybillStatus (status) {
  switch (status) {
    case 'New':
      return '待处理'
    case 'Processing':
      return '处理中'
    case 'Completed':
      return '已完成'
    case 'Cancelled':
      return '已取消'
    case 'Suspended':
      return '暂停'
    default:
      return status
  }
}

/**
 * 库存状态转译
 * @param {String} status 库存状态
 */
export function getStoreStatus (status) {
  switch (status) {
    case 'WaitingForMatch':
      return '待匹配' // 待处理时、挂起时用到这个状态
    case 'ToReplenish':
      return '需补货' // 库存+在途尚不满足需求
    case 'InTransit':
      return '在途' // 库存+在途已满足需求
    case 'InPutOnShelf':
      return '上架中' // 库存（含上架中）已满足需求
    case 'StockReady':
      return '在库' // 库存（不含上架）已满足需求
    default:
      return status
  }
}

/**
 * 禁用日期规则，禁用今天之前的日期
 * @param {Date} time 选择的时间
 */
export function disabledDate (time) {
  return time.getTime() < new Date().getTime()
}

// 转换成货币格式
// 正则
const digitsRE = /(\d{3})(?=\d)/g

/**
 * 转换成货币类型
 * @param {Number} value 要转换的数值
 * @param {String} currency 要转换的货币单位
 * @param {Number} decimals 小数点后几位
 */
export function changeCurrency (value, currency, decimals) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : '$'
  decimals = decimals != null ? decimals : 2
  var stringified = Math.abs(value).toFixed(decimals)
  var _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  var i = _int.length % 3
  var head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  var _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  var sign = value < 0 ? '-' : ''
  return sign + currency + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float
}

/**
 * 手机号码验证-正则
 * @param {String} phoneNumber 手机号码
 */
export function checkPhone (phoneNumber) {
  if ((/^1(3|4|5|6|7|8|9)\d{9}$/.test(phoneNumber))) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/index.js